<template>
    <div>
        <sau-template :retrieved="gotData">
            <!-- Fetching Placeholder -->
            <template slot="message">Fetching Domain Nameservers</template>

            <!-- Data -->
            <template slot="data">
                <div class="row">
                    <div class="col">
                        <h3>
                            Nameservers:
                            <span
                                class="sau-font sm"
                                v-if="!canUpdateDomain"
                            >- Updating nameservers is only available with active domains</span>
                        </h3>

                        <!-- check for empty nameservers first -->
                        <div v-if="noFormData">
                            <sau-apiro-response type="error" support="true">
                                <template
                                    slot="message"
                                >We were unable to retrieve your nameservers.</template>
                                <template slot="details">
                                    <p>If you would like further details please contact our Support Team.</p>
                                </template>
                            </sau-apiro-response>
                        </div>

                        <div class="sau-bx bx-pad clearfix" v-else>
                            <form>
                                <div class="container">
                                    <div class="row" v-if="canUpdateDomain">
                                        <template v-for="(ns, index) in form">
                                            <div
                                                class="col-lg-6"
                                                v-if="index != 'domainid' && index != 'dnsConfigType'"
                                                :key="index"
                                            >
                                                <div class="form-group">
                                                    <label
                                                        :for="`ns-${index}`"
                                                    >{{ index.toUpperCase() }}</label>
                                                    <input
                                                        type="text"
                                                        class="form-control"
                                                        v-model="form[index]"
                                                        :id="`ns-${index}`"
                                                    >
                                                    <div v-if="index == 'ns1' || index == 'ns2'">
                                                        <small class="text-muted">* Required</small>
                                                    </div>
                                                    <div v-else>
                                                        <small class="text-muted">* Optional</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </div>

                                    <!-- Cancelled domain - no update available -->
                                    <div v-else class="row">
                                        <template v-for="(ns, index) in form">
                                            <div
                                                class="col-lg-6"
                                                v-if="index != 'domainid' && index != 'dnsConfigType' && form[index] != ''"
                                                :key="index"
                                            >
                                                <ul class="sau-list-display">
                                                    <li>
                                                        <h5>{{ index.toUpperCase() }}</h5>
                                                        <p>{{ form[index] }}</p>
                                                    </li>
                                                </ul>
                                            </div>
                                        </template>
                                    </div>

                                    <div class="float-right pt-4" v-if="canUpdateDomain">
                                        <a :href="domainDetailsLink">Cancel</a>
                                        <button
                                            href="#"
                                            @click.prevent="updateNameservers()"
                                            class="btn ml-4 btn-success"
                                            :disabled="submitting"
                                        >
                                            Update
                                            <i
                                                v-if="submitting"
                                                class="far fa-spinner-third fa-spin"
                                            ></i>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </template>
        </sau-template>
    </div>
</template>
<script>
export default {
    props: ['domain'],
    data() {
        return {
            nameservers: '',
            submitting: false,
            form: {
                domainid: '',
                ns1: '',
                ns2: '',
                ns3: '',
                ns4: '',
                ns5: ''
            }
        };
    },
    created() {
        this.startApp();
        this.form.domainid = this.domain.id;
    },
    computed: {
        noFormData() {
            let data = true;
            _.forIn(this.form, function(val, key) {
                if (key == 'domainid') return;
                if (!val) return;
                data = false;
            });
            return data;
        }
    },
    methods: {
        startApp() {
            this.getDomainNameservers()
                .then(response => {
                    if (response.data.nameservers) {
                        this.nameservers = response.data.nameservers;
                        this.formatDetails();
                    }
                })
                .catch(error => {});
        },
        formatDetails() {
            // Limit nameservers to defined (5). Some registrars pass back up to 12 nameservers, but only allow for updating 5
            _.forIn(
                this.nameservers,
                function(val, key) {
                    if (this.form[key] !== undefined) {
                        this.form[key] = val;
                    }
                }.bind(this)
            );
        },
        updateNameservers() {
            this.submitting = true;
            this.updateDomainNameservers(this.form)
                .then(response => {
                    if (response.data.data.result == 'success') {
                        this.$swal({
                            type: 'success',
                            title: 'Nameservers Updated',
                            showConfirmButton: false,
                            timer: 3000
                        });
                    } else {
                        let message = response.data.data.message
                            ? response.data.data.message
                            : 'Something went wrong';
                        let feedback = response.data.data.error
                            ? response.data.data.error
                            : 'There was an issue updating the nameservers';
                        this.$swal({
                            type: 'error',
                            title: message,
                            html: feedback,
                            showConfirmButton: true,
                            confirmButtonClass: 'btn btn-danger',
                            buttonsStyling: false
                        });
                    }
                    this.submitting = false;
                })
                .catch(error => {
                    this.$swal({
                        type: 'error',
                        title: 'Something went wrong',
                        showConfirmButton: false,
                        timer: 3000
                    });
                    this.submitting = false;
                });
        }
    }
};
</script>
